//

import { normalize } from 'normalizr';
import moment from 'moment';

import { simplApi } from '../../api/simplApi';

import { serviceType } from './schemas';
import { dateFormat } from '../../helpers/formats';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_SERVICETYPE = 'REQUEST_SERVICETYPE';
export const RECEIVE_SERVICETYPE = 'RECEIVE_SERVICETYPE';
export const SET_SERVICETYPE = 'SET_SERVICETYPE';
export const SET_SERVICETYPE_FORM = 'SET_SERVICETYPE_FORM';
export const CLOSE_SERVICETYPE_FORM = 'CLOSE_SERVICETYPE_FORM';
export const REMOVE_SERVICETYPE = 'REMOVE_SERVICETYPE';

// ------------------------------------
// Actions
// ------------------------------------

export function requestServiceType() {
  return {
    type: REQUEST_SERVICETYPE,
  };
}

export function receiveServiceType(serviceTypes) {
  return {
    type: RECEIVE_SERVICETYPE,
    payload: {
      serviceTypes,
    },
  };
}

export function setServiceType(serviceTypeId) {
  // console.log('action setServiceType', serviceTypeId);
  return {
    type: SET_SERVICETYPE,
    payload: serviceTypeId,
  };
}

export function setServiceTypeForm(serviceTypeId = '') {
  return {
    type: SET_SERVICETYPE_FORM,
    payload: serviceTypeId,
  };
}

export function closeServiceTypeForm() {
  return {
    type: CLOSE_SERVICETYPE_FORM,
  };
}

export const fetchServiceType = serviceTypeId => dispatch => {
  dispatch(requestServiceType());

  const url =
    typeof serviceTypeId !== 'undefined' && serviceTypeId !== null
      ? `serviceType/${serviceTypeId}`
      : 'serviceType';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedServiceTypes;

        if (typeof json.serviceTypes !== 'undefined') {
          preparedServiceTypes = normalize(json, {
            serviceTypes: [serviceType],
          });
        } else {
          preparedServiceTypes = normalize(json, {
            serviceType,
          });
        }

        // // console.log('prepping comps', preparedServiceTypes)

        dispatch(
          receiveServiceType(preparedServiceTypes.entities.serviceTypes),
        );
        dispatch(fetchTotalData());
      }
    });
};

export function removeServiceType(serviceTypeId) {
  return {
    type: REMOVE_SERVICETYPE,
    payload: serviceTypeId,
  };
}

export const deleteServiceType = serviceTypeId => dispatch => {
  const url = `serviceType/${serviceTypeId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removeServiceType(serviceTypeId));
      }
    });
};

export const saveServiceType = newServiceType => dispatch => {
  // console.log('attempting to save an serviceType!');

  dispatch(requestServiceType());

  let url = 'serviceType/';
  const options = { method: 'post', body: newServiceType };
  if (typeof newServiceType.id !== 'undefined' && newServiceType.id !== null) {
    url = `${url}${newServiceType.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
      } else {
        const preparedServiceTypes = normalize(json, serviceType);

        dispatch(
          receiveServiceType(preparedServiceTypes.entities.serviceTypes),
        );
      }
    });
};

export const actions = {
  requestServiceType,
  receiveServiceType,
  fetchServiceType,
  setServiceType,
  setServiceTypeForm,
  closeServiceTypeForm,
  saveServiceType,
  deleteServiceType,
  removeServiceType,
};

const SERVICETYPE_ACTION_HANDLERS = {
  [REQUEST_SERVICETYPE]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_SERVICETYPE]: (state, action) => ({ ...state, current: action.payload }),
  [SET_SERVICETYPE_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_SERVICETYPE]: (state, action) => ({
    ...state,
    serviceTypes: _.omit(state.serviceTypes, action.payload),
  }),
  [CLOSE_SERVICETYPE_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_SERVICETYPE]: (state, action) => {
    const stateServiceTypes = state.serviceTypes;

    _.forOwn(action.payload.serviceTypes, (_serviceType, id) => {
      const newServiceType = _serviceType;
      const newMeta = {};

      _.forOwn(_serviceType.meta, value => {
        newMeta[value.key] = value;
      });

      newServiceType.meta = newMeta;

      newServiceType.createdDate = moment(_serviceType.created_at).format(
        dateFormat,
      );

      if (typeof stateServiceTypes[id] === 'object') {
        Object.assign(
          stateServiceTypes[id],
          stateServiceTypes[id],
          newServiceType,
        );
      } else {
        stateServiceTypes[id] = newServiceType;
      }
    });

    return {
      ...state,
      serviceTypes: stateServiceTypes,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  current: null,
  formOpen: false,
  formTarget: null,
  fetching: false,
  serviceTypes: {},
};
export default function serviceTypeReducer(state = initialState, action) {
  const handler = SERVICETYPE_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/servicetype.js